import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { authFetch } from '../utils/authFetch';
import { applyDiscount, canDiscountPrice, discountPercent, findDiscountPart } from './discount';

export default function InvoiceDiscount({ doc, disabled, onApply, makeUid }) {
  const [show, setShow] = useState(false);
  const [mode, setMode] = useState('invoice');
  const [percent, setPercent] = useState('');
  const [selectedUid, setSelectedUid] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const inFlight = useRef(false);
  const current = useRef({ doc, disabled });
  current.current = { doc, disabled };
  useEffect(() => () => { current.current = { disabled: true }; }, []);

  const apply = async () => {
    if (inFlight.current || disabled) return;
    inFlight.current = true;
    setError(''); setLoading(true);
    const snapshot = JSON.stringify(doc);
    try {
      discountPercent(percent);
      const part = mode === 'invoice' ? await findDiscountPart(authFetch) : null;
      if (current.current.disabled || JSON.stringify(current.current.doc) !== snapshot)
        throw new Error('Factura s-a modificat. Verifică liniile și aplică din nou discountul.');
      const lines = applyDiscount(doc.linii, { mode, percent, selectedUid, part, makeUid });
      onApply(lines);
      setShow(false);
    } catch (e) {
      setError(e.message || 'Discountul nu a putut fi aplicat.');
    } finally {
      inFlight.current = false; setLoading(false);
    }
  };
  return <>
    <Button type="button" variant="outline-primary" disabled={disabled || !doc.linii?.length}
      onClick={() => { setShow(true); setError(''); setPercent(''); }}>Discount %</Button>
    <Modal show={show} onHide={() => !loading && setShow(false)} backdrop="static" centered>
      <Modal.Header closeButton={!loading}><Modal.Title>Discount pe factură</Modal.Title></Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger" role="alert">{error}</Alert>}
        <fieldset disabled={loading || disabled}>
          <legend className="fs-6">Mod de acordare</legend>
          {[
            ['invoice', 'Pe toată factura — linii separate cu minus'],
            ['all', 'Pe toate liniile — scade prețurile'],
            ['line', 'Pe linia aleasă — scade prețul'],
          ].map(([value, label]) => <Form.Check key={value} type="radio" name="invoice-discount-mode"
            id={`invoice-discount-${value}`} label={label} checked={mode === value} onChange={() => setMode(value)} />)}
          {mode === 'invoice' ? <p className="text-muted small mt-2">Se adaugă linii DISCOUNT separate pe cote TVA, în moneda facturii. Procentul se aplică bazei rămase după discounturile existente.</p>
            : <p className="text-muted small mt-2">Procentul se aplică prețurilor curente. Liniile de discount și storno nu se modifică.</p>}
          {mode === 'line' && <Form.Group className="mb-3" controlId="invoice-discount-selected-line">
            <Form.Label>Linia facturii</Form.Label>
            <Form.Select value={selectedUid} onChange={e => setSelectedUid(e.target.value)}>
              <option value="">Alege linia</option>
              {(doc.linii || []).map((line, index) => canDiscountPrice(line) && <option key={line.uid} value={line.uid}>
                {index + 1}. {line.descriere || line.bxpart_label} — {Number(line.price).toFixed(4)}
              </option>)}
            </Form.Select>
          </Form.Group>}
          <Form.Group controlId="invoice-discount-percent">
            <Form.Label>Procent discount (%)</Form.Label>
            <Form.Control autoFocus inputMode="decimal" value={percent} placeholder="Ex.: 10 sau 2,5"
              onChange={e => setPercent(e.target.value)} />
          </Form.Group>
        </fieldset>
        <p className="text-muted small mt-3 mb-0">După aplicare, salvează factura pentru a păstra modificările.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="secondary" disabled={loading} onClick={() => setShow(false)}>Renunță</Button>
        <Button type="button" disabled={loading || disabled} onClick={apply}>{loading ? 'Se aplică…' : 'Aplică discount'}</Button>
      </Modal.Footer>
    </Modal>
  </>;
}
